module.exports = __webpack_public_path__ + "close.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = 136
// module chunks = 0